const trailsDetailMetaInfo = {
  meta: {
    columns: []
  }
}

export { trailsDetailMetaInfo }



// WEBPACK FOOTER //
// ./src/column-header/trail/trail-details-meta.js